import script from "./HomeMask.vue?vue&type=script&setup=true&lang=ts"
export * from "./HomeMask.vue?vue&type=script&setup=true&lang=ts"

import "./HomeMask.vue?vue&type=style&index=0&id=8c3949a4&scoped=true&lang=less"

import exportComponent from "/Users/neal/Desktop/www/qingtv/qingtv-back-new/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-8c3949a4"]])

export default __exports__